import {
  Component,
  Injector,
  HostListener,
  OnInit,
  ElementRef,
  Renderer2,
  AfterViewInit,
  OnDestroy,
  ComponentFactoryResolver,
  ViewChild,
  ViewContainerRef,
  Compiler,
} from '@angular/core';
import { ProductService } from '../../services/productservice';
import { DomSanitizer } from '@angular/platform-browser';
import { latestVideoService } from '../../services/latestVideo.service';
import { highlightsProductsService } from '../../services/highlightsProducts.service';
const CAT_TESTIMONIAL: string = 'destination';
import { CategoriesComponent } from '../categories/categories.component'; // Adjust the path as necessary
import { LatestvideoComponent } from '../latestvideo/latestvideo.component'; // Adjust the path as necessary
import { HighlightsComponent } from '../highLights/highlights/highlights.component'; // Adjust the path as necessary
import { HomeTestimonialComponent } from '../@shared/home-testimonial/home-testimonial.component'; // Adjust the path as necessary
import { InstagramComponent } from '../instagram/instagram.component'; // Adjust the path as necessary

export class ProductVideo {
  videoURL: any;
}

@Component({
  selector: 'app-legacy-home',
  templateUrl: './legacy-home.component.html',
  styleUrls: ['./legacy-home.component.scss'],
})
export class LegacyHomeComponent implements OnInit, AfterViewInit, OnDestroy {
  private mutationObserver: MutationObserver;
  highlightsProducts: any = [];
  latestVideos: any;
  bannerVideos: any = [];
  public pageNumber = 0;
  videoid = 0;
  videoSource: any;
  isPlay: boolean = false;
  language: string;
  TestMonialData: any[] = [];
  testimonialResponsive: any;
  mobileImg3: any = '';

  @ViewChild('categoriesContainer', { read: ViewContainerRef }) categoriesContainer: ViewContainerRef;
  @ViewChild('latestVideosContainer', { read: ViewContainerRef }) latestVideosContainer: ViewContainerRef;
  @ViewChild('highlightsContainer', { read: ViewContainerRef }) highlightsContainer: ViewContainerRef;
  @ViewChild('testimonialContainer', { read: ViewContainerRef }) testimonialContainer: ViewContainerRef;
  @ViewChild('instagramContainer', { read: ViewContainerRef }) instagramContainer: ViewContainerRef;

  private categoriesObserver: IntersectionObserver;
  private latestVideosObserver: IntersectionObserver;
  private highlightsObserver: IntersectionObserver;
  private testimonialObserver: IntersectionObserver;
  private instagramObserver: IntersectionObserver;

  public categoriesRendered = false;
  public latestVideosRendered = false;
  public highlightRendered = false;
  public testimonialRendered = false;
  public instagramRendered = false;

  constructor(
    private productService: ProductService,
    private _sanitizer: DomSanitizer,
    private el: ElementRef,
    private renderer: Renderer2,
    private injector: Injector,
    private componentFactoryResolver: ComponentFactoryResolver,
    private compiler: Compiler,
    private latestVideoService: latestVideoService,
    private highlightsProductsService: highlightsProductsService
  ) {
    this.testimonialResponsive = [
      {
        breakpoint: '1024px',
        numVisible: 1,
        numScroll: 1,
      },
      {
        breakpoint: '768px',
        numVisible: 1,
        numScroll: 1,
      },
      {
        breakpoint: '640px',
        numVisible: 1,
        numScroll: 1,
      },
      {
        breakpoint: '480px',
        numVisible: 1,
        numScroll: 1,
      },
    ];
  }

  private initializeObservers() {
    const options: any = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1,
    };

    this.categoriesObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !this.categoriesRendered) {
          this.categoriesRendered = true;
          this.loadCategoriesContainer();
          this.categoriesObserver.unobserve(entry.target);
        }
      });
    }, options);

    this.latestVideosObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !this.latestVideosRendered) {
          this.latestVideosRendered = true;
          this.loadLatestVideosContainer();
          this.latestVideosObserver.unobserve(entry.target);
        }
      });
    }, options);

    this.highlightsObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !this.highlightRendered) {
          this.highlightRendered = true;
          this.loadHighlightsContainer();
          this.highlightsObserver.unobserve(entry.target);
        }
      });
    }, options);

    this.testimonialObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !this.testimonialRendered) {
          this.testimonialRendered = true;
          this.loadTestimonialContainer();
          this.testimonialObserver.unobserve(entry.target);
        }
      });
    }, options);

    this.instagramObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !this.instagramRendered) {
          this.instagramRendered = true;
          this.loadInstagramContainer();
          this.instagramObserver.unobserve(entry.target);
        }
      });
    }, options);

    this.observeContainers();
  }

  private observeContainers() {
    if (this.categoriesContainer) {
      this.categoriesObserver.observe(this.categoriesContainer.element.nativeElement);
    }
    if (this.latestVideosContainer) {
      this.latestVideosObserver.observe(this.latestVideosContainer.element.nativeElement);
    }
    if (this.highlightsContainer) {
      this.highlightsObserver.observe(this.highlightsContainer.element.nativeElement);
    }
    if (this.testimonialContainer) {
      this.testimonialObserver.observe(this.testimonialContainer.element.nativeElement);
    }
    if (this.instagramContainer) {
      this.instagramObserver.observe(this.instagramContainer.element.nativeElement);
    }
  }

  private disconnectObservers() {
    if (this.categoriesObserver) this.categoriesObserver.disconnect();
    if (this.latestVideosObserver) this.latestVideosObserver.disconnect();
    if (this.highlightsObserver) this.highlightsObserver.disconnect();
    if (this.testimonialObserver) this.testimonialObserver.disconnect();
    if (this.instagramObserver) this.instagramObserver.disconnect();
  }

  private loadCategoriesContainer() {
    import('../lazy.module')
      .then(({ LazyModule }) => {
        this.compiler.compileModuleAsync(LazyModule).then((moduleFactory) => {
          const moduleRef = moduleFactory.create(this.injector);
          const componentFactory = moduleRef.componentFactoryResolver.resolveComponentFactory(CategoriesComponent);
          const { instance } = this.categoriesContainer.createComponent(componentFactory);
        });
      })
      .catch((error) => {
        console.error('Failed to load module:', error);
      });
  }

  private loadLatestVideosContainer() {
    import('../lazy.module')
      .then(({ LazyModule }) => {
        this.compiler
          .compileModuleAsync(LazyModule)
          .then((moduleFactory) => {
            const moduleRef = moduleFactory.create(this.injector);
            const componentFactory = moduleRef.componentFactoryResolver.resolveComponentFactory(LatestvideoComponent);
            this.latestVideosContainer.createComponent(componentFactory);
          })
          .catch((error) => console.error('Error compiling module:', error));
      })
      .catch((error) => console.error('Error importing LatestvideoComponent:', error));
  }

  private loadHighlightsContainer() {
    import('../lazy.module')
      .then(({ LazyModule }) => {
        this.compiler
          .compileModuleAsync(LazyModule)
          .then((moduleFactory) => {
            const moduleRef = moduleFactory.create(this.injector);
            const componentFactory = moduleRef.componentFactoryResolver.resolveComponentFactory(HighlightsComponent);
            this.highlightsContainer.createComponent(componentFactory);
          })
          .catch((error) => console.error('Error compiling module:', error));
      })
      .catch((error) => console.error('Error importing HighlightsComponent:', error));
  }

  private loadTestimonialContainer() {
    import('../lazy.module')
      .then(({ LazyModule }) => {
        this.compiler
          .compileModuleAsync(LazyModule)
          .then((moduleFactory) => {
            const moduleRef = moduleFactory.create(this.injector);
            const componentFactory = moduleRef.componentFactoryResolver.resolveComponentFactory(
              HomeTestimonialComponent
            );
            this.testimonialContainer.createComponent(componentFactory);
          })
          .catch((error) => console.error('Error compiling module:', error));
      })
      .catch((error) => console.error('Error importing HomeTestimonialComponent:', error));
  }

  private loadInstagramContainer() {
    import('../lazy.module')
      .then(({ LazyModule }) => {
        this.compiler
          .compileModuleAsync(LazyModule)
          .then((moduleFactory) => {
            const moduleRef = moduleFactory.create(this.injector);
            const componentFactory = moduleRef.componentFactoryResolver.resolveComponentFactory(InstagramComponent);
            this.instagramContainer.createComponent(componentFactory);
          })
          .catch((error) => console.error('Error compiling module:', error));
      })
      .catch((error) => console.error('Error importing InstagramComponent:', error));
  }

  adjustPopup() {
    const $cookieConsentButton = $('[aria-label="Cookie Consent Prompt"]');
    // Select the alert popup
    const $alertPopup = $('.alert-popup');

    // Check if the cookie consent button exists
    if ($cookieConsentButton.length > 0) {
      // If the cookie consent button exists, set the alert popup's top to 180px
      $alertPopup.css('top', '180px');
    } else {
      // If the cookie consent button does not exist, remove the top style from the alert popup
      $alertPopup.css('top', '');
    }
  }

  ngAfterViewInit() {
    this.initializeObservers();

    $(document).on('click', '[data-tid="banner-accept"]', function () {
      setTimeout(() => {
        const $cookieConsentButton = $('[aria-label="Cookie Consent Prompt"]');
        const $alertPopup = $('.alert-popup');
        if ($cookieConsentButton.length > 0) {
          $alertPopup.css('top', '180px');
        } else {
          $alertPopup.css('top', '');
        }
      }, 500);
    });

    $(document).on('click', '[data-tid="banner-decline"]', function () {
      setTimeout(() => {
        const $cookieConsentButton = $('[aria-label="Cookie Consent Prompt"]');
        const $alertPopup = $('.alert-popup');
        if ($cookieConsentButton.length > 0) {
          $alertPopup.css('top', '180px');
        } else {
          $alertPopup.css('top', '');
        }
      }, 500);
    });
  }

  ngOnDestroy() {
    this.disconnectObservers();
    window.removeEventListener('resize', this.adjustImageSize);
  }

  ngOnInit() {
    this.language = localStorage.getItem('language').toLocaleLowerCase();
    this.banner();
    this.loadData();
    this.getTestiMonial();
    const int = setInterval(() => {
      if (this.mobileImg3 != '' && this.mobileImg3 != null) {
        clearInterval(int);
      }

      this.adjustImageSize();
    }, 100);
    window.addEventListener('resize', this.adjustImageSize);

    // Google Ads Conversion Tracking for Homepage Visit
    // Track any visitor coming with URL parameters (campaigns, ads, etc.)
    const hasUrlParameters = window.location.search.length > 0;

    if (hasUrlParameters) {
      console.log('CAMPAIGN TRAFFIC DETECTED - Parameters:', window.location.search);
      if (typeof (window as any).gtag === 'function') {
        (window as any).gtag('event', 'conversion', { send_to: 'AW-715415142/zyRZCNzR46AZEOa8kdUC' });
      }
    }

    // Subscribe to scroll events
    // this.ScrollService.onScroll().subscribe((event: Event) => { // Modify to accept Event type
    //   this.handleScroll(event); // Pass the event to handleScroll
    // });
  }

  adjustImageSize() {
    this.mobileImg3 = document.getElementById('mobileimg3');
    const mobileImg4 = document.getElementById('mobileimg4');
    if (this.mobileImg3 != '' && this.mobileImg3 != null) {
      const browserWidth = window.innerWidth;
      let imageSize = browserWidth / 3;
      this.mobileImg3.style.width = `${imageSize}px`;

      let imageSize4 = browserWidth / 4.5;
      mobileImg4.style.width = `${imageSize4}px`;
    }
  }

  getTestiMonial() {
    try {
      this.productService.getTestiMonial().then((res) => {
        this.TestMonialData = res.filter(
          (item: any) => item.field_special_intrest.toLowerCase() === CAT_TESTIMONIAL.toLowerCase()
        );
        if (this.TestMonialData.length > 0) {
          setTimeout(() => {
            ($('.testimonial-flipster') as any).flipster({
              style: 'flat',
              buttons: true,
              scrollwheel: false,
              loop: true,
              spacing: -0.05,
            });
          }, 1000);
        }
      });
    } catch (error) {}
  }
  setVideoHandlers() {
    let playState: any = null;
    var video: any = document.getElementById('my_video_1');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          video.pause();
          playState = false;
        } else {
          video.play();
          playState = true;
        }
      });
    }, {});

    observer.observe(video);

    const onVisibilityChange = () => {
      if (document.hidden || !playState) {
        video.pause();
      } else {
        video.play();
      }
    };

    document.addEventListener('visibilitychange', onVisibilityChange);
  }

  banner() {
    this.productService.getBannerVideos().then((data) => {
      for (var i = 0; i < data.length; i++) {
        var res = data[i].url.split('?');
        this.bannerVideos[i] = res[0];
      }
      this.videoSource = this.bannerVideos[this.videoid];
      setTimeout(() => {
        this.playPause();
      }, 1000);
    });
    this.setVideoHandlers();
  }

  bannerVideoUrl(url: any) {
    return this._sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  playPause() {
    let video: any = document.querySelector('#my_video_1');
    video.src = this.videoSource;
    video.muted = true;
    video.play();
  }
  nextPrevious(n: any) {
    this.showVideos((this.videoid += n));
  }
  showVideos(n: any) {
    var myVideo: any = document.getElementById('my_video_1');
    var i;
    var x = this.bannerVideos;
    if (n > x.length - 1) {
      this.videoid = 0;
    }
    if (n < 0) {
      this.videoid = x.length - 1;
    }
    this.videoSource = this.bannerVideos[this.videoid];
    myVideo.src = this.videoSource;
    if (myVideo.paused) myVideo.play();
    else myVideo.pause();
  }

  loadData() {
    //Latest Videos
    this.productService.getLatestvideos().then((products) => {
      this.latestVideos = products.map((p: any) => {
        var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
        var match = p.videos.match(regExp);
        if (match && match[7].length == 11) {
          p['video'] = match[7];
        }
        p['videos'] = this._sanitizer.bypassSecurityTrustResourceUrl(p.videos);
        return p;
      });
      this.latestVideoService.setVideoProducts(this.latestVideos);
    });
    this.productService.getHighlightSmallPagingDescOrder(this.pageNumber, this.language, '').then((products) => {
      if (products.results.length > 0) {
        this.highlightsProducts = this.specialInterestFilter(products.results);
        this.highlightsProductsService.setHighlightsProducts(this.highlightsProducts);
        this.language = localStorage.getItem('language').toLocaleLowerCase();
        this.highlightsProducts.forEach((element: any) => {
          var queryParams = this.productService.getBlogViewNode(element);
          element['url'] = '/blog-details/' + element.nid + '/' + queryParams;
        });
      }
    });
  }
  specialInterestFilter(highlightItems: any) {
    Array.from(highlightItems).map((data: any) => {
      data.title = data.title.replace('&#039;', "'");
      // let [num, specialIntrest] = data.field_special_intrest.toLowerCase().split(':');
      let specialIntrest =
        data.field_blog_category !== undefined ? data.field_blog_category.toLowerCase() : data.field_blog_category;
      specialIntrest = specialIntrest.replace(/&amp;/g, '&');
      switch (specialIntrest) {
        case 'things to do':
          data.specialInterestName = 'Things to do';
          data.specialIntersetIcon = 'icon-icons8-scuba-mask-50';
          break;
        case 'focus':
          data.specialInterestName = 'Focus';
          data.specialIntersetIcon = 'icon-icons8-sail-boat-50';
          break;
        case 'sustainability':
          data.specialInterestName = 'Sustainability';
          data.specialIntersetIcon = 'icon-icons8-fishing-50';
          break;
        case 'travel tips':
          data.specialInterestName = 'Travel Tips';
          data.specialIntersetIcon = 'icon-icons8-home-office-50';
          break;
        case 'romance':
          data.specialInterestName = 'Romance';
          data.specialIntersetIcon = 'icon-icons8-romance-50';
          break;
        case 'nature & wildlife':
          data.specialInterestName = 'Nature & Wildlife';
          data.specialIntersetIcon = 'icon-icons8-leaf-50';
          break;
        case 'culture':
          data.specialInterestName = 'Culture';
          data.specialIntersetIcon = 'icon-icons8-romance-50';
        // default:
        //   data.specialInterestName = this.sanitizer.bypassSecurityTrustResourceUrl('');
        //   break;
      }
    });
    return highlightItems;
  }

  /******** VIDOE CHANGES *****8 */
  scollBottom() {
    window.scrollTo({
      top: 540,
      behavior: 'smooth',
    });
  }
}
